var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex flex-column width-100"},_vm._l((_vm.combinedActions),function(action){return _c('ActionDetailsItem',{key:action.id,attrs:{"action":action,"noBorder":_vm.actions.length === 1}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }